// reactstrap components
import React, { useEffect } from "react";

import Container from "reactstrap/lib/Container";

import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button } from "reactstrap";

function Event({ text, location }) {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928 ? true : false;
  useEffect(() => {
    const common = {
      containment: "#bgndVideo2",
      autoPlay: true,
      mute: true,
      startAt: 0,
      opacity: 1,
      loop: false,
      ratio: "4/3",
      addRaster: true,
    };

    const videos = [
      {
        videoURL: "ApujYg-6QME",
        ...common,
      },
    ];
    if (size) {
      window.jQuery("#bgndVideo2").YTPlaylist(videos, false);
    }
  }, []);

  return (
    <div className="section pt-0" style={{ backgroundColor: !size ? "#000" : "transparent" }}>
      {size && (
        <div
          style={{
            background: "#000",
            position: "absolute",
            top: 0,
            width: "100%",
            zIndex: -100,
            marginLeft: "auto",
            marginRight: "auto",
            pointerEvents: "none",
            // marginTop: "3.5rem",
          }}
        >
          <div
            id="bgndVideo2"
            className="section player"
            style={{ background: "transparent" }}
          ></div>
        </div>
      )}
      {size && <div className="overlay-primary" />}
      <div className="page-header" style={{ background: "transparent" }} data-parallax={true}>
        <Container>
          <Row className="text-700 justify-content-center" style={{ marginTop: "2rem" }}>
            <Col lg={6} className="mb-5">
              <h1 className="text-700 text-white">Why Attend?</h1>
              <hr />
              <h5 className="text-400 text-white">
                Step into a transformative experience at Finnovex Middle East 2025, where 200+
                senior decision-makers from across the GCC’s financial and technology sectors
                converge to spark innovation, explore partnerships, and redefine the future of
                finance. This high-impact summit is purposefully crafted to address the region’s
                most critical challenges and uncover new growth opportunities—equipping you with
                actionable strategies to lead in a rapidly evolving landscape.
              </h5>
              <Button
                href="/delegates/3"
                className="btn my-2 text-center px-5 rounded-0"
                color="primary"
                size="md"
              >
                <b>Learn More</b>
              </Button>
            </Col>
            <Col lg={6}>
              <h1 className="text-700 text-white">Why Sponsor?</h1>
              <hr />
              <h5 className="text-400 text-white">
                Partner with us to connect with C-level leaders and decision-makers from banking,
                fintech, regulatory bodies, and technology sectors. Showcase your expertise, launch
                new products, and generate meaningful leads in a high-impact environment designed
                for business acceleration.
              </h5>
              <Button
                href="/partners"
                className="btn my-2 text-center px-5 rounded-0"
                color="primary"
                size="md"
              >
                <b>BECOME A SPONSOR</b>
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Event;
